class AuthorisationInterceptor {

  /* ngInject */
  constructor($q, $state, $window) {
    this.$q = $q;
    this.$state = $state;
    this.$window = $window;
  }

  request = (config) => {

    // if there is a token add it to each http request
    var token = this.$window.localStorage.authToken;
    if(token){
      config.headers.Authorization = 'Bearer ' + token;
    }

    return config;

  };

  response = (response) => {

    // if there is a token returned save it for future requests
    if (response.data.token) {
      this.$window.localStorage.authToken = response.data.token;
    }

    return response;

  };

  responseError = (rejection) => {

    // Unauthorised
    if (rejection.status === 401) {

      // redirect to login
      this.$state.go('login');

      // Return a new promise (required by angular interceptor)
      return this.$q.reject(rejection);
    }

    /* If not a 401, do nothing with this error.
     * This is necessary to make a `responseError`
     * interceptor a no-op. */
    return this.$q.reject(rejection);
  }
}

AuthorisationInterceptor.$inject = ['$q', '$state', '$window'];
export default AuthorisationInterceptor;
